function Index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function ChangePassword() {
  return import(
    /* webpackChunkName: "page-change-password" */ '@/pages/change-password.vue'
  )
}
function Leaderboards() {
  return import(
    /* webpackChunkName: "page-leaderboards" */ '@/pages/leaderboards.vue'
  )
}
function ProfileUsernameIndex() {
  return import(
    /* webpackChunkName: "page-profile-username-index" */ '@/pages/profile/_username/index.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: Index
  },
  {
    name: 'change-password',
    path: 'change-password',
    component: ChangePassword
  },
  {
    name: 'leaderboards',
    path: 'leaderboards',
    component: Leaderboards
  },
  {
    name: 'profile-username-index',
    path: 'profile/:username',
    component: ProfileUsernameIndex
  }
]
